<script setup lang="ts">import { $api } from "@client/lib/trpc";import { useUserStore as ___useUserStore } from "@client/stores"; const $$user =  ___useUserStore();import {useRouter as ___useRouter} from "vue-router";const $router = ___useRouter();
import { EyeIcon, EyeOffIcon, XIcon } from "lucide-vue-next";

const shouldShow = defineModel("show", { type: Boolean, required: true });
const visibleComponent = defineModel("component", { type: String, required: true });

const form = ref(getInitialFormData()),
	errorMessage = ref<string>(),
	showPassword = ref(false);

const handleLogin = async () => {
	try {
		if (!canLogin.value) return;
		const credentials = await $api.auth.login.mutate({ ...form.value });
		$$user.saveCredentials(credentials);
		$$user.friendList = await $api.friends.list.query();
		$$user.requests.incoming = await $api.friends.requests.incoming.query();

		resetForm();
		shouldShow.value = false;
		$router.push({ name: "lobby" });
	} catch (error: any) {
		errorMessage.value = error.data.message;
	}
};

const resetForm = () => (form.value = getInitialFormData());
const handleGoToRegister = () => {
	resetForm();
	visibleComponent.value = "register";
};
const handleForgotPassword = () => alert(`Keep trying! You'll get it`);
const canLogin = computed(() => form.value.usernameOrEmail && form.value.password);
function getInitialFormData() {
	return { usernameOrEmail: "", password: "" };
}
</script>
<template>
	<v-dialog
		v-if="shouldShow"
		v-model="shouldShow"
		@after-leave="resetForm"
		minWidth="320px"
		maxWidth="30%"
		maxHeight="95%">
		<v-card class="rounded-xl py-5 hide-scrollbar">
			<v-alert
				min-height="fit-content"
				v-if="errorMessage"
				:text="errorMessage"
				closable
				class="mx-16 mb-2 py-2 text-body-2 font-rubik"
				color="#DD2C00" />
			<template #title>
				<div class="d-flex justify-center align-center">
					<span class="tw:text-2xl font-weight-bold tw:basis-full tw:text-center">
						Login
					</span>
					<XIcon
						@click="shouldShow = false"
						class="tw:cursor-pointer tw:hover:scale-125 tw:mr-3"
						:size="20" />
				</div>
			</template>

			<v-card-item class="px-16">
				<v-form @keyup.enter="handleLogin">
					<p>Username</p>
					<v-text-field
						autocomplete="username"
						v-model="form.usernameOrEmail"
						@update:model-value="errorMessage = ''"
						flat
						variant="solo-filled" />
					<p>Password</p>
					<v-text-field
						autocomplete="current-password"
						v-model="form.password"
						@update:model-value="errorMessage = ''"
						:type="showPassword ? 'text' : 'password'"
						flat
						variant="solo-filled">
						<template #append-inner>
							<component
								@click="showPassword = !showPassword"
								:is="showPassword ? EyeOffIcon : EyeIcon"
								class="tw:cursor-pointer"
								:size="20" />
						</template>
					</v-text-field>
				</v-form>

				<div class="d-flex flex-column ga-2 px-2">
					<div class="d-flex align-center text-caption ga-2">
						<v-checkbox-btn density="compact">
							<template #label>
								<span class="text-caption font-rubik"> Remember me </span>
							</template>
						</v-checkbox-btn>
						<a
							@click="handleForgotPassword"
							class="flex-1-0-0 text-right text-decoration-underline text-medium-emphasis cursor-pointer font-rubik">
							Forgot Password?
						</a>
					</div>
					<v-btn
						rounded
						class="mx-1 text-none text-body-1 font-rubik"
						color="primary"
						height="50"
						v-disabled-click="!canLogin"
						@click="handleLogin">
						Login
					</v-btn>
					<p class="pt-2 text-center tw:text-sm text-medium-emphasis">
						Don't have an account?
						<button
							@click="handleGoToRegister"
							class="text-high-emphasis cursor-pointer">
							Register
						</button>
					</p>
				</div>
			</v-card-item>
		</v-card>
	</v-dialog>
</template>
